import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule} from '@angular/material/button';

import { DateSelectDialog } from './date-select-dialog.component';

@NgModule({
  declarations: [
    DateSelectDialog
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [
    DateSelectDialog
  ]
})
export class DateSelectDialogModule { }
